import { EnumUtil } from './common'

// ========== 1. 性别枚举（业务配置） ==========
export const GenderEnum = new EnumUtil({
  MALE: { value: 0, label: '男' },
  FEMALE: { value: 1, label: '女' },
  UNKNOWN: { value: 2, label: '未知' }
})

export const OrderStatusEnum = new EnumUtil({
  PENDING: { value: 0, label: '待支付' },
  PAID: { value: 1, label: '已支付' },
  SHIPPED: { value: 2, label: '已发货' },
  COMPLETED: { value: 3, label: '已完成' },
  CANCELLED: { value: 4, label: '已取消' }
})

export const CourseCategoryEnum = new EnumUtil({
  PLATFORM: { value: 0, label: '平台' },
  UNIVERSITY: { value: 1, label: '院校' },
  THIRD_PARTY: { value: 2, label: '三方' }
})
export enum PlatformType {
  SELF_STUDY = 1, // 自考
  ADULT_EDUCATION = 2, // 成教
  COMPREHENSIVE_EVALUATION = 3 // 综合评价
}

export const platformTypeEnum = new EnumUtil({
  SELF_STUDY: { value: PlatformType.SELF_STUDY, label: '自考' },
  ADULT_EDUCATION: { value: PlatformType.ADULT_EDUCATION, label: '成教' },
  COMPREHENSIVE_EVALUATION: {
    value: PlatformType.COMPREHENSIVE_EVALUATION,
    label: '综合评价'
  }
})
export const openCourseTypeEnum = new EnumUtil({
  PROVINCIAL_EXAM: { value: 1, label: '省考' },
  UNIFIED_EXAM: { value: 2, label: '统考' },
  PROVINCIAL_AND_UNIFIED_EXAM: { value: 2, label: '省考和统考' },
  SINGLE_SUBJECT: { value: 2, label: '单科' }
})
